import { render, staticRenderFns } from "./BmvKanban.vue?vue&type=template&id=6a36b4e4&scoped=true"
import script from "./BmvKanban.vue?vue&type=script&lang=js"
export * from "./BmvKanban.vue?vue&type=script&lang=js"
import style0 from "./BmvKanban.vue?vue&type=style&index=0&id=6a36b4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36b4e4",
  null
  
)

export default component.exports